;(function(factory) {

    var runFactory = function() {
        // conditional factory logic should be placed here.
        if (typeof jQuery == 'undefined') {
            return setTimeout(runFactory, 100);
        }

        factory(jQuery);
    };

    runFactory();
    
})(function($) {
    /**
     * Check if the given variable is a function.
     * @param  {Function} functionToCheck The variable to be checked.
     * @return {Boolean}                  True if function false otherwise.
     */
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Filters the vars to avoid data containing special characters.
     * 
     * @return {Object} A JSON object containing the url variables.
     */
    function getURLVars() {
        var vars = {}, hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var second = hashes[hashes.length - 1];

        if (second.substring(second.length-1 )== "#") {
            hashes[hashes.length-1] = hashes[hashes.length-1].substring(0, hashes[hashes.length-1].length-1);
        }

        for(var i = hashes.length-1; i >= 0; i--) {
            if (/http/.test(hashes[i])) {
                continue;
            }
            hash = hashes[i].split('=');
    
            if(hash.length > 2){
                var key = hash.shift();
                var val = hash.join('=');
                vars[key] = val;
            } else {
                vars[hash[0]] = hash[1];
            }
        }
    
        return vars;
    }

    /**
     * Given a key it gets the value of the parameter in URL.
     * 
     * @param  {String} sParam The parameter to retrieve.
     * @param  {String} defVal The value to return if no parameter is set.
     * @return {String}        The value of the parameter.
     */
    function getUrlParameter(sParam, defVal) {
        var vars = getURLVars();

        return vars[sParam] || defVal;
    }

    /**
     * Given the parameter name and value it provides the URL with that 
     * parameter added or updated.
     * URL can be ommited in which case the window current location will be
     * used as base URI value.
     * 
     * @param {String} key   The parameter name.
     * @param {String} value The parameter new value.
     * @param {String} uri   The URL to change the parameter for. [Optional]
     * 
     * @returns {String}     The URL with the right parameters.
     */
    function setUrlParameter(key, value, uri) {
        var uri = uri || window.location;
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";

        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }

        return uri + separator + key + "=" + value;
    }

    /**
     * Given a script url loads it and executes the callback.
     * @param  {String}   url      The url of the script to be loaded.
     * @param  {Function} callback The callback to be executed when loaded.
     * @param  {Boolean}           True to load the script async.
     * @return {void}
     */
    function loadScript(url, callback, async) {
        console.log('Loading URL: ' + url);

        if (typeof async == 'undefined') {
            async = false;
        }

        var script = document.createElement("script")
        script.type = "text/javascript";
        script.async = async;

        if (script.readyState){  //IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    if (isFunction(callback)) {
                        callback();
                    }
                }
            };
        } else {  //Others
            script.onload = function() {
                if (isFunction(callback)) {
                    callback();
                }
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }

    /**
     * Given a style url loads itin the page.
     * @param  {String}   url      The url of the script to be loaded.
     * @return {void}
     */
    function loadStyle(url) {
        console.log('Loading URL: ' + url);

        var link = document.createElement("link")
        link.type = "text/css";   
        link.rel = "stylesheet";
        link.media = "screen,print";
        link.href = url;

        document.getElementsByTagName("head")[0].appendChild(link);
    }

    /**
     * Given a script url loads it and executes the callback.
     * @param  {String}   url      The url of the script to be loaded.
     * @param  {Function} callback The callback to be executed when loaded.
     * @return {void}
     */
    function loadAsyncScript(url, callback) {
        loadScript(url, callback, true);
    }

    /**
     * Check if the provided attribute is a date.
     * 
     * @param  {Mixed}   d  The value to check. 
     * 
     * @return {Boolean}    false
     */
    function isDate(d) {
        if (Object.prototype.toString.call(d) === "[object Date]") {
            // it is a date
            if (isNaN(d.getTime())) {  // d.valueOf() could also work
                return false; // date is not valid
            } else {
                return true; // date is valid
            }
        } else {
            return false; // not a date
        }
    }
    
    /**
     * Provided a 16 charachter string of numbers it checks if it's a valid
     * credit card number.
     * 
     * @param  {String}   val It should be 16 charachter number string i.e. 9999999999999999
     * @return {Boolean}      true if it passes the check false otherwise.
     */
    function luhnCheck(val) {
        var sum = 0;
        for (var i = 0; i < val.length; i++) {
            var intVal = parseInt(val.substr(i, 1));
            if (i % 2 == 0) {
                intVal *= 2;
                if (intVal > 9) {
                    intVal = 1 + (intVal % 10);
                }
            }
            sum += intVal;
        }
        return (sum % 10) == 0;
    }

    /**
     * Provided an html DOM event, it supresses it and stops the bubling effect.
     * 
     * @param {Object} ev The event to supress.
     */
    function supressEvent(ev) {
        
    }

    /**
     * Use this function as a wrapper around dataLayer for tracking events in the site.
     * 
     * @param {String} gtmEvent  The event name that we want to report.
     * @param {String} gtmCate   The event category that needs to be added. 
     * @param {String} gtmAction The event action that needs to be added.
     * @param {String} gtmLabel  The event lablet that needs to be added.
     * @param {String} gtmValue  The event value that needs to be added.
     */
    function trackEvent (gtmEvent, gtmCate, gtmAction, gtmLabel, gtmValue) {
        if (typeof dataLayer == 'undefined' || !Lum.checkFunction(dataLayer.push)) {
            return;
        }

        dataLayer.push({
            event: (gtmEvent || ''),
            eventCategory: (gtmCate || ''),
            eventAction: (gtmAction || ''),
            eventLabel: (gtmLabel || ''),
            eventValue: (gtmValue || '')
        });
    }

    /**
     * Adds events on click for elements that have the class 'track-click-event'.
     * 
     * ex. class="track-click-event" 
     */
    function initEventTracking() {
        $(document).off('click', '.track-click-event', trackClickEvent);
        $(document).on('click', '.track-click-event', trackClickEvent);
    }

    /**
     * This function gets the data-gtm- of the element and based on those it adds
     * the GTM event to the dataLayer.
     * 
     * [data-gtm-event] 
     * [data-gtm-category] 
     * [data-gtm-action] 
     * [data-gtm-label] 
     * [data-gtm-value] 
     * 
     * ex. data-gtm-category="Mailing List Subscription" data-gtm-action="Submitted"
     * 
     * @param {DOMElement} ev The element that has the click handler.
     */
    function trackClickEvent(ev) {
        console.log('Clicked tracking object.', this, $(this).data('event'));
        var gtmEvent =  $(this).data('gtm-event') || '';
        var gtmCate = $(this).data('gtm-category') || '';
        var gtmAction = $(this).data('gtm-action') || '';
        var gtmLabel = $(this).data('gtm-label') || '';
        var gtmValue = $(this).data('gtm-value') || '';

        trackEvent(gtmEvent, gtmCate, gtmAction, gtmLabel, gtmValue);
    }

    function blazyRevalidate() {
        if (typeof Blazy == 'undefined') {
            return setTimeout(blazyRevalidate, 100);
        }

        if (typeof Lum.bLazy == 'undefined' ) {
            Lum.bLazy = new Blazy();
        }
        
        Lum.bLazy.revalidate();
    }

    /**
     * Check if all modules related are loaded.
     * @return {Boolean}
     */
    function checkModulesLoaded() {
        return window.Blazy;
    }

    /**
     * Keep the file versioned.
     * @return {String}
     */
    var version = function() {
        return '1.1.8';
    };

    var Lum = function () {
        this.loadScript = function(url, callback, async) {
            return loadScript(url, callback, async);
        };

        this.loadStyle = function(url) {
            return loadStyle(url);
        };

        this.loadScriptAsync = function(url, callback) {
            return loadAsyncScript(url, callback);
        };

        this.checkFunction = function(functionToCheck) {
            return isFunction(functionToCheck);
        };

        this.isDate = function(dateObj) {
            return isDate(dateObj);
        };

        this.getUrlParameter = function(sParam, defVal) {
            return getUrlParameter(sParam, defVal);
        };

        this.setUrlParameter = function(paramKey, paramVal, uri) {
            return setUrlParameter(paramKey, paramVal, uri);
        };

        this.getUrlParameters = function() {
            return getURLVars();
        };

        this.blazyRevalidate = function() {
            return blazyRevalidate();
        };

        this.version = function() {
            return version();
        };

        this.checkCard = function (creditCardNumber) {
            return luhnCheck(creditCardNumber);
        };

        this.supressEvent = function (ev) {
            return supressEvent(ev);
        };

        this.trackEvent = function (gtmEvent, gtmCate, gtmAction, gtmLabel, gtmValue) {
            return trackEvent(gtmEvent, gtmCate, gtmAction, gtmLabel, gtmValue);
        };

        this.initEventTracking = function () {
            return initEventTracking();
        };

        this.isLoaded = function () {
            return checkModulesLoaded();
        };

        return this;
    };

    initEventTracking();

    window.Lum = new Lum();
});
